import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WorkspaceFile } from '../types';

interface FileState {
  files: WorkspaceFile[];
  selectedFiles: string[];
  multiSelectMode: boolean;
  viewMode: 'list' | 'grid';
  sortBy: 'name' | 'date' | 'size';
  sortOrder: 'asc' | 'desc';
}

const initialState: FileState = {
  files: [],
  selectedFiles: [],
  multiSelectMode: false,
  viewMode: 'list',
  sortBy: 'name',
  sortOrder: 'asc',
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setFiles: (state, action: PayloadAction<WorkspaceFile[]>) => {
      state.files = action.payload;
    },
    setSelectedFiles: (state, action: PayloadAction<string[]>) => {
      state.selectedFiles = action.payload;
    },
    toggleFileSelection: (state, action: PayloadAction<string>) => {
      const path = action.payload;
      if (state.selectedFiles.includes(path)) {
        state.selectedFiles = state.selectedFiles.filter((p) => p !== path);
      } else {
        state.selectedFiles.push(path);
      }
    },
    clearSelection: (state) => {
      state.selectedFiles = [];
    },
    setMultiSelectMode: (state, action: PayloadAction<boolean>) => {
      state.multiSelectMode = action.payload;
      if (!action.payload) {
        state.selectedFiles = [];
      }
    },
    setViewMode: (state, action: PayloadAction<'list' | 'grid'>) => {
      state.viewMode = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'name' | 'date' | 'size'>) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortOrder = action.payload;
    },
  },
});

export const {
  setFiles,
  setSelectedFiles,
  toggleFileSelection,
  clearSelection,
  setMultiSelectMode,
  setViewMode,
  setSortBy,
  setSortOrder,
} = fileSlice.actions;

export default fileSlice.reducer;
